<template>
  <section>
    <PageBackButton route-name="ProfileOverview" />

    <h1 class="pg_title">{{ $_translations.value.page_profile_edit_title }}</h1>

    <h2 class="subtitle">{{ $_translations.value.page_profile_edit_subtitle }}</h2>
  </section>
</template>

<script setup>
import PageBackButton from '@/components/button/PageBackButton.vue';
</script>
